export default "<ion-button (click)=\"toggleArchived()\" expand=\"block\" color=\"dark\">Toggle archived</ion-button>"